export const DOC_TYPES = {
    CC: {
        VALUE: 'CC',
        TEXT: 'C.C.',
    },
    CE: {
        VALUE: 'CE',
        TEXT: 'C.E.',
    },
    NIT: {
        VALUE: 'NIT',
        TEXT: 'NIT',
    },
};

export const DOC_TYPES_BY_CLIENT_TYPE = {
    N: {
        CC: {
            VALUE: 'CC',
            TEXT: 'C.C.',
        },
        CE: {
            VALUE: 'CE',
            TEXT: 'C.E.',
        },
    },
    J: {
        NIT: {
            VALUE: 'NIT',
            TEXT: 'NIT',
        },
    },
};

export const DOC_TYPES_EXTERNAL = {
    DNI: {
        VALUE: 'DNI',
        TEXT: 'DNI',
    },
};

export const DOC_TYPES_CR = {
    CI: {
        VALUE: 'CEDULA DE IDENTIDAD',
        TEXT: 'CÉDULA DE IDENTIDAD',
    },
};

export const DOC_TYPES_LAFISE = {
    CC: {
        VALUE: 'CI',
        TEXT: 'CÉDULA DE IDENTIDAD',
    },
};

export const DOC_TYPES_NIUBIZ = {
    DNI: {
        VALUE: 'CC',
        TEXT: 'DNI',
    },
    RUC: {
        VALUE: 'CC',
        TEXT: 'RUC',
    },
    CE: {
        VALUE: 'CC',
        TEXT: 'CE',
    },
};

export const DOC_TYPES_REDEBAN = {
    CC: {
        VALUE: 'CC',
        TEXT: 'C.C.',
    },
    NIT: {
        VALUE: 'NIT',
        TEXT: 'NIT',
    },
    CE: {
        VALUE: 'CE',
        TEXT: 'C.E.',
    },
};

export const DOC_TYPES_QR = {
    CC: {
        VALUE: 'CC',
        TEXT: 'Cédula de ciudadanía',
    },
    CD: {
        VALUE: 'CD',
        TEXT: 'C.D.',
    },
    CE: {
        VALUE: 'CE',
        TEXT: 'Cédula de extranjería',
    },
    NIT: {
        VALUE: 'NIT',
        TEXT: 'NIT',
    },
    TI: {
        VALUE: 'TI',
        TEXT: 'Tarjeta de identidad',
    },
    PASS: {
        VALUE: 'PAS',
        TEXT: 'Pasaporte',
    },
};

export const DOC_TYPES_DAVIPLATA = [
    {
        value: 'CC',
        text: 'Cédula de ciudadanía',
    },
    {
        value: 'CE',
        text: 'Cédula de extranjería',
    },
    {
        value: 'TI',
        text: 'Tarjeta de identidad',
    },
];

export const DOC_TYPES_CDC = [
    {
        value: 'CC',
        text: 'Cédula de ciudadanía',
    },
    {
        value: 'CE',
        text: 'Cédula de extranjería',
    },
    {
        value: 'TI',
        text: 'Tarjeta de identidad',
    },
    {
        value: 'PS',
        text: 'Pasaporte',
    },
    {
        value: 'CD',
        text: 'Carné diplomático',
    },
];
